import React, { Component } from 'react';
import Radium from 'radium'

class Home extends Component{

  render(){
    return null;
  };
}

export default Radium(Home)



// WEBPACK FOOTER //
// ./src/home/Home.js